module.exports = __webpack_public_path__ + "static/img/video01.c5e5f268.jpg";